export const GAME_TITLE = {
    FORTNITE: 'fortnite',
    ROCKET_LEAGUE: 'rocketleague',
    SIDE_SWIPE: 'sideswipe',
    FALL_GUYS: 'fallguys'
};
